<script setup lang="ts" generic="TColumn extends {}">
import GwTableTh from '@/components/lib/GwTable/GwTableTh.vue'
import GwCheckbox from '@/components/lib/GwCheckbox/GwCheckbox.vue'
import type {
  GwTableCheckBoxState,
  GwTableColumn,
  GwTableSortConf,
  GwTableVariantConf,
} from './gwTableUtils'
import GwBox from '../GwBox/GwBox.vue'

export interface GwTableHeadProps<TColumn> {
  columns: GwTableColumn<TColumn>[]
  hasCheckbox?: boolean
  checkboxState?: GwTableCheckBoxState
  sortConf?: GwTableSortConf<GwTableColumn<TColumn>['sortKey']>
  variantConf: GwTableVariantConf['head']
}

withDefaults(defineProps<GwTableHeadProps<TColumn>>(), {
  checkboxState: 'none',
})

type GwTableHeadEmits = {
  'select:all': []
  'th:click': [Event, GwTableColumn<TColumn>]
  'th:mousedown': [Event, GwTableColumn<TColumn>]
  'th:mouseup': [Event, GwTableColumn<TColumn>]
  'th:touchstart': [Event, GwTableColumn<TColumn>]
  'th:touchend': [Event, GwTableColumn<TColumn>]
}

const emit = defineEmits<GwTableHeadEmits>()
</script>

<template>
  <GwBox
    tag="thead"
    :variant="variantConf.variant"
  >
    <th
      v-if="hasCheckbox"
      style="width: 0; height: 100%; z-index: 6"
      class="gwtable_th_sticky_left gwtable_th_checkbox"
    >
      <div style="height: 100%; width: 100%">
        <GwCheckbox
          data-tst="select_all"
          :selected="['all', 'some'].includes(checkboxState)"
          :indeterminate="checkboxState === 'some'"
          @change="emit('select:all')"
        />
      </div>
    </th>

    <slot
      v-for="(item, index) in columns"
      :item="item"
    >
      <GwTableTh
        :item
        :sortConf
        :data-tst="`th_${item.field}`"
        :variant="variantConf.th.variant"
        @th:click="(e, item) => emit('th:click', e, item)"
        @th:mousedown="(e, item) => emit('th:mousedown', e, item)"
        @th:mouseup="(e, item) => emit('th:mouseup', e, item)"
        @th:touchstart="(e, item) => emit('th:touchstart', e, item)"
        @th:touchend="(e, item) => emit('th:touchend', e, item)"
      >
        <template #thcell_before="{}">
          <slot
            name="thcell_before"
            :item="item"
          ></slot>
        </template>
      </GwTableTh>
    </slot>
  </GwBox>
</template>
